import { useSelector } from "react-redux";

const ManufacturingProducts = () => {
  return (
    <>
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iiplwork.retool.com/embedded/public/ba91cdd1-1cb7-449c-bd98-3e1e85083266"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default ManufacturingProducts;
